export default __webpack_public_path__ + "static/media/android-original.a2a0d5d5.svg";